<template>
  <component :is="component"></component>
</template>
<script>

import Func51 from '@/views/51/Func51Listagem'

export default {
  name: 'Func10',
  data () {
    return {
      component: Func51
    }
  }
}
</script>
